import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {Card, CardActionArea, CardContent, CardHeader, Grid} from "@mui/material";
import {useLocation} from "react-router";

type ReportEntry = {
    link:string,
    title:string,
    more:string
}

const data:ReportEntry[] = [
  { link: '/imports/costs-import', title: 'Cost Import', more: 'Import Costs For Campaigns (Excel .xlsx)' },
  { link: '/imports/invoice-import', title: 'Invoice Import', more: 'Import Invoice No For Campaigns (Excel .xlsx)' },
  { link: '/imports/site-pops-import', title: 'POPS Import', more: 'Import POPS Links For Sites (Excel .xlsx)' },
];

data.sort((a:ReportEntry, b:ReportEntry) => {  if(a.title <b.title) return -1; if(a.title>b.title) return 1; return 0; } );

const Imports = () => {
  const navigate = useNavigate();
  const toolbarContext = useContext(ToolbarContext);
  const location= useLocation();
  const goto = (loc) => () => {
    navigate(loc);
  }
  useEffect(() => {
    toolbarContext.setPrimary(
      {
        primary: [],
        title: 'Reports',
         primaryUrl:location.pathname
      });
  }, []);

  return (
    <div className="settings is-scrollable">
        <Grid container spacing={2}>
        {
          data.map((item) => (
            <Grid key={item.link} item md={3} xs={12}>
                <Card>
                    <CardActionArea onClick={goto(item.link)}>
                        <CardHeader title={item.title} variant="h5" sx={{ paddingBottom: 0 }} />
                        <CardContent>{item.more}</CardContent>
                    </CardActionArea>
                </Card>
            </Grid>
          ))
        }
      </Grid>
    </div>
  );
}


export default Imports;
